export default __webpack_public_path__ + "maps-overview-annotation-view-1200-b565d1318f7ea7d4410ff3ac62b11c32.webp";